import React from 'react';
import { Link } from 'react-router-dom';

export default ({ badge }) => {
  return (
    <div className="badges--widget">
      <h3>Last Badge Received</h3>
      {badge ? (
        <div className="badges--widget__last-badge">
          <div className="badges--widget__last-badge--wrapper">
            <div className="badges--widget__badge-img" style={{ backgroundImage: `url(${badge.image.location})` }} />
            <h4>{badge.name}</h4>
            <p>
              Awarded for the completion of {badge.course && badge.course.name ? badge.course.name : badge.chapter.name}
            </p>
          </div>
          <div className="badges--widget__button-wrapper">
            <Link className="button button--theme--outline" to={'/subscription/profile'}>
              View All
            </Link>
          </div>
        </div>
      ) : (
        <div className="badges--widget__empty-msg">
          <p>No Badges yet!</p>
          <p>Get started on a <Link to={'/subscription/courses'}>Course</Link> to earn Badges.</p>
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/subscription/dashboard/BadgeWidget.js